import { Title } from '../../../components'
import {
    Container
} from './styles'

export default function (){
    return (
        <Container>
            <div className="row">
                <div className="col">
                    <Title>Documentação</Title>

                    <section className="mt-2 p-3">

                        <p>
                            Axial Osso utilizar ww 2.500 e wl 500;<br/>
                            Axial, sagital e coronal P.M. S/C e C/C utilizar ww 250 e wl 40;<br/>
                        </p>
                        <p>
                            <b>Axial Osso -</b> 1 filme na formatação de 24 imagens;<br/>
                            <b>Axial P.M. S/C -</b> 1 filme na formatação de 24 imagens;<br/>
                            <b>Axial P.M. C/C -</b> 1 filme na formatação de 24 imagens;<br/>
                            <b>Sagital P.M. C/C -</b> 1 filme na formatação de 20 imagens;<br/>
                            <b>Coronal P.M. C/C -</b> 1 filme na formatação de 20 imagens;<br/>
                        </p>

                        <p>Sempre que utilizar o meio de contraste I.V. identificar no filme.</p>

                        <p>
                            <b>Impressão Mista, Filme e Papel</b><br/>
                            Axial em filme; <br/>
                            Sagital em papel;<br/>
                            Coronal em papel;<br/>
                        </p>
                        <p>
                            <b>Impressão apenas em Papel</b><br/>
                            Axial em papel;<br/>
                            Sagital em papel;<br/>
                            Coronal em papel;<br/>
                        </p>
                    </section>
                </div>
            </div>
        </Container>
    )
}